import React, { useEffect, useState } from 'react';
import styles from './articleNumber.scss';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../types';
import * as helper from '../../../helpers/html-helper';

function ArticleInfo({ info }: { info: string }) {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => { setIsMounted(true) }, []);

    if (!isMounted || !info) {
        return null;
    }

    return (
        <React.Fragment>
            <span className={styles.article_info}>{info}</span>
        </React.Fragment>);
}

const ArticleNumber = inject('store')(
    observer(({ store, isStickyHeader }: IInjectedProps) => {
        const count = store?.dataStore.orderModule.sortedBrickSelections
            .reduce((acc, v) => acc + v.includedQuantity, 0);
        const localizedCountText = `${count} ${helper.decodeHTML(count === 1
            ? store?.localization.generalL10n.setArticleCountSingle
            : store?.localization.generalL10n.setArticleCountMany) || ''}`;
        const title = store?.dataStore.orderModule.flexSetInfo.displayName;

        return (
            <div className={styles.article_number_container}>
                <h1 role='heading' className={styles.article_title}>
                    {/* TODO for debugging mixedMedia, will be romoved */}
                    {store?.debuggerIsOn &&
                        < div className={styles.debug_buttons}>
                            <button className={styles.button} onClick={() => store?.addBrick()}>+</button>
                            <button className={styles.button} onClick={() => store?.removeBrick()}>-</button>
                            <button className={styles.button} onClick={() => store?.switchSetImage()}>&</button>
                        </div>}



                    {!isStickyHeader &&
                        (<span className={styles.article_number}>#{store?.dataStore.orderModule.flexSetInfo.fsCode}</span>)
                    }
                    <span className={styles.article_designation}>{title ? title : null}</span>
                    <ArticleInfo info={localizedCountText} />
                </h1 >
            </div >
        );
    })
);

export default ArticleNumber;
